"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var WithdrawalIsAccept = function (_a) {
    var onClose = _a.onClose, amount = _a.amount, children = _a.children, method = _a.method;
    var t = (0, next_intl_1.useTranslations)('translation');
    var date = (0, date_fns_1.format)(new Date(), 'dd-LL-yy HH:mm:ss');
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, width: "335px", height: "auto", portalNodeId: "modal", onClose: onClose, showClose: false, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title, dangerouslySetInnerHTML: {
                    __html: t.raw('withdrawalRequestAccepted'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text, dangerouslySetInnerHTML: {
                    __html: t.raw('withdrawalRequestAcceptedText'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.amount }, amount),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.amountText, dangerouslySetInnerHTML: {
                    __html: t.raw('withdrawalRequestAcceptedAmount'),
                } }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.values },
                children,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null,
                        t('date'),
                        ":"),
                    react_1.default.createElement("b", null, date))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.info, dangerouslySetInnerHTML: {
                    __html: t.raw('withdrawalRequestAcceptedInfo'),
                } }),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: onClose, maxWidth: "100%" }, t('ok')))));
};
exports.default = WithdrawalIsAccept;
